import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'
// 持久化vuex插件
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

/** 使用webpack require方法动态注入modules */
const modulesFiles = require.context('./modules', true, /\.js$/)

// brian 2022 04 22
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})


const store = new Vuex.Store({
  mutations,
  state,
  getters,
  modules,
  actions,
  plugins: [
    createPersistedState({
      reducer(val) {
        return {
          app: val.app,
          permission: val.permission,
          userInfo: val.userInfo,
          avatar: val.avatar,
          SchemaTree: val.SchemaTree,
            treeUserId: val.treeUserId,
            CURRENT_SYSTEM_MENU: val.CURRENT_SYSTEM_MENU,

        };
      }
    })
  ]
})
export default store

